(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["company-project-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('company-project-gallery')) {
    customElements.define('company-project-gallery', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-project-slide]'));
        this.counter = this.querySelector('[data-project-counter]');
        this.current = 0;
        this.querySelector('[data-project-previous]')?.addEventListener('click', () => this.show(this.current - 1));
        this.querySelector('[data-project-next]')?.addEventListener('click', () => this.show(this.current + 1));
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-project-slide]');
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.show(index);
        });
      }

      show(index) {
        if (!this.slides?.length) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== this.current;
          const video = slide.querySelector('video');
          if (video && slide.hidden) video.pause();
        });
        if (this.counter) this.counter.textContent = `${this.current + 1} / ${this.slides.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
